import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { getWeddingPageByType, getWeddingPageByTypeV2 } from '../../../actions/PublicWebsiteActions';
import { resetEntities } from '../../../actions/website/EntityActions';
import { getImageUrl } from '../../../cards/util/imageHelper';

const chunkArray = (array) => {
  const a = array.slice();
  const ret = [];
  let i = 0;
  while (a.length > 0) {
    if (i % 5 === 1 || i % 5 === 4) {
      ret.push(a.slice(0, 5));
      a.splice(0, 5);
    } else {
      ret.push(a.slice(0, 4));
      a.splice(0, 4);
    }
    i += 1;
  }
  return ret;
};

class Photos extends Component {
  constructor(props) {
    super(props);
    this.showLightbox = this.showLightbox.bind(this);
    this.closeLightbox = this.closeLightbox.bind(this);
    this.handleClick = this.handleClick.bind(this);

    this.state = {
      lightboxOpen: false,
      openPhoto: null,
      currentIndex: 0,
    };
  }

  componentDidMount() {
    const { getPhotos, forPreview, getPhotosV2 } = this.props;
    const production = window.zola.env === 'production';
    if (!forPreview && production) {
      getPhotos();
    } else if (!forPreview && !production) {
      getPhotosV2();
    }
  }

  componentWillUnmount() {
    const { unloadEntities, forPreview } = this.props;
    if (!forPreview) {
      unloadEntities();
    }
  }

  showLightbox(photo) {
    const { photos } = this.props;
    const idx = photos.indexOf(photo);
    this.setState({ lightboxOpen: true, openPhoto: photo, currentIndex: idx });
    document.body.classList.add('no-scroll');
  }

  closeLightbox() {
    this.setState({ lightboxOpen: false, openPhoto: null, currentIndex: 0 });
    document.body.classList.remove('no-scroll');
  }

  handleClick(e) {
    if (e.target !== this.photoSection) {
      this.closeLightbox();
    }
  }

  render() {
    const { photos, orderedIds, page, forPreview, busy, wedding } = this.props;
    return (
      <div id="photos-page" className="container">
        {page && !busy && (
          <div className={['cms-page-header', (!page.description && !page.header_image_url ? 'flex-container' : null)].join(' ')}>
            <div className="cms-header-accent-top-left" />
            <div className="cms-header-accent-top-right" />
            <div className="cms-header-accent-bottom-left" />
            <div className="cms-header-accent-bottom-right" />
            <h1 className="for-small-laptops">{page.title}</h1>
            {window.zola.env !== 'production' ? (
              <span>
                {page.header_image_url && (
                  <img src={`${page.header_image_url}?h=400`} alt={`The Wedding Website of ${wedding.owner_first_name} ${wedding.owner_last_name} and ${wedding.partner_first_name} ${wedding.partner_last_name}`} className="img-responsive center-block" />
                )}
              </span>
            ) : (
              <span>
                {page.header_image_url && (
                  <img src={`${page.header_image_url}?h=400`} alt={page.title} className="img-responsive center-block" />
                )}
              </span>
            )}
            {page.description && (
              <p className={['page-description', (page.header_image_url ? 'has-image-above' : null)].join(' ')}>{page.description}</p>
            )}
          </div>
        )}
        <div className="entity-sections photo-sections">
          <div className="entity-sections-accent-top-left" />
          <div className="entity-sections-accent-top-right" />
          <div className="entity-sections-accent-bottom-left" />
          <div className="entity-sections-accent-bottom-right" />
          {forPreview && photos && chunkArray(orderedIds, 4).map((photoIdChunk, idx) => (
            <div className="photo-row" key={idx}>
              {photoIdChunk.map((photoId, i) => (
                <div className={`photo-container photo-${i + 1}`} key={i}>
                  {photos[photoId].image_id && (
                    <div
                      className="photo"
                      style={{ backgroundImage: `url(${getImageUrl(photos[photoId].image_id)}?w=800&h=800)` }}
                    />
                  )}
                </div>
              ))}
            </div>
          ))}
          {!forPreview && photos && chunkArray(photos, 4).map((photoChunk, idx) => (
            <div className="photo-row" key={idx}>
              {photoChunk.map((photo, i) => (
                <div className={`photo-container photo-${i + 1}`} key={i}>
                  {window.zola.env !== 'production' ? (
                    <span>
                      {photo.image_id && (
                        <img
                          className="photo"
                          alt={`${wedding.owner_first_name} ${wedding.owner_last_name} and ${wedding.partner_first_name} ${wedding.partner_last_name}'s Wedding Website`}
                          src={`${getImageUrl(photo.image_id)}?w=800&h=800`}
                          onClick={() => this.showLightbox(photo, i)}
                          role="button"
                        />
                      )}
                    </span>
                  ) : (
                    <span>
                      {photo.image_id && (
                        <div
                          className="photo"
                          style={{ backgroundImage: `url(${getImageUrl(photo.image_id)}?w=800&h=800)` }}
                          onClick={() => this.showLightbox(photo, i)}
                          role="button"
                        />
                      )}
                    </span>
                  )}
                  {photo.caption && (
                    <p className="visible-xs">
                      {photo.caption}
                    </p>
                  )}
                </div>
              ))}
            </div>
          ))}
          {((forPreview && orderedIds && orderedIds.length === 0) || (!forPreview && photos && photos.length === 0)) && (
            <p className="text-center empty-entity-text">Visuals to come...</p>
          )}
        </div>
        {this.state.lightboxOpen && (
          <div className="lightbox hidden-xs" onClick={this.handleClick}>
            <div className="photo-container text-center">
              <div className="lightbox-close zolaicon-public zolaicon-public-close" role="button" onClick={this.closeLightbox} />
              <div className="slideshow-container">
                <div className="arrow-left">
                  <span
                    className={`zolaicon-public zolaicon-public-chevron-left${this.state.currentIndex > 0 ? '' : ' invisible'}`}
                    role="button"
                    onClick={(e) => {
                      this.showLightbox(photos[this.state.currentIndex - 1], this.state.currentIndex - 1);
                      e.stopPropagation();
                      e.nativeEvent.stopImmediatePropagation();
                    }}
                  />
                </div>
                <div className="photo-section">
                  <img
                    src={`${getImageUrl(this.state.openPhoto.image_id)}?w=800&h=800`}
                    alt=""
                    className="center-block img-responsive photo"
                    ref={(el) => { this.photoSection = el; }}
                  />
                </div>
                <div className="arrow-right">
                  <span
                    className={`zolaicon-public zolaicon-public-chevron-right${this.state.currentIndex < photos.length - 1 ? '' : ' invisible'}`}
                    role="button"
                    onClick={(e) => {
                      this.showLightbox(photos[this.state.currentIndex + 1], this.state.currentIndex + 1);
                      e.stopPropagation();
                      e.nativeEvent.stopImmediatePropagation();
                    }}
                  />
                </div>
              </div>
              {this.state.openPhoto.caption && (
                <p className="photo-caption">
                  {this.state.openPhoto.caption}
                </p>
              )}
            </div>
          </div>
        )}
      </div>
    );
  }
}

Photos.propTypes = {
  photos: PropTypes.oneOfType([PropTypes.shape({}), PropTypes.arrayOf(PropTypes.shape({}))]),
  orderedIds: PropTypes.arrayOf(PropTypes.number),
  getPhotos: PropTypes.func,
  unloadEntities: PropTypes.func,
  forPreview: PropTypes.bool,
  page: PropTypes.shape({}).isRequired,
  busy: PropTypes.bool,
  wedding: PropTypes.shape({}),
  getPhotosV2: PropTypes.func.isRequired
};

const mapStateToProps = (state, ownProps) => (
  {
    photos: ownProps.forPreview ? state.website.entities.byId : state.publicWebsite.entities,
    orderedIds: ownProps.forPreview ? state.website.entities.orderedIds : null,
    page: ownProps.forPreview ? ownProps.page : state.publicWebsite.page,
    busy: state.publicWebsite.busy,
    wedding: state.publicWebsite.wedding
  }
);

const mapDispatchToProps = dispatch => (
  {
    getPhotos: () => {
      dispatch(getWeddingPageByType('photos'));
    },
    getPhotosV2: () => {
      dispatch(getWeddingPageByTypeV2('photos'));
    },
    unloadEntities: () => dispatch(resetEntities())
  }
);

const PhotosContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(Photos);

export default PhotosContainer;



/** WEBPACK FOOTER **
 ** ./src/components/PublicWebsite/pages/Photos.jsx
 **/